import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { TokenCookieService } from "../service/token-storage-cookies.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private tokenCookieService: TokenCookieService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let currentUser = this.tokenCookieService.getUser();

    if (currentUser) {
      // The backend may return the JWT as either `accessToken` or `token`
      const accessToken = currentUser.accessToken ?? currentUser.token;

      // Utility function to return "GUEST" if the value is null, undefined or empty string
      const getSafeValue = (value: string | null | undefined): string => {
        return value ? value : "GUEST";
      };

      const headers = new HttpHeaders({
        Authorization: `${"Bearer " + accessToken}`,
        UserName: `${currentUser.username}`,
        DepartmentCode: getSafeValue(currentUser.departmentCode),
        BranchCode: getSafeValue(currentUser.branchCode),
        CostCenterCode: getSafeValue(currentUser.costCenterCode),
        MemberCode: getSafeValue(currentUser.empPfNo),
      });

      const cloneReq = request.clone({ headers, withCredentials: false });
      // console.log("cloneReq: ", cloneReq);
      return next.handle(cloneReq);
    } else if (!currentUser) {
      const accessToken = 'GUEST';
      let currentUserTest = {
        username: "GUEST",
        departmentCode: "GUEST",
        branchCode: "GUEST",
        costCenterCode: "GUEST",
        empPfNo: "GUEST",
      };
      const headers = new HttpHeaders({
        Authorization: `${"Bearer " + accessToken}`,
        UserName: `${currentUserTest.username}`,
        DepartmentCode: `${currentUserTest.departmentCode}`,
        BranchCode: `${currentUserTest.branchCode}`,
        CostCenterCode: `${currentUserTest.costCenterCode}`,
        MemberCode: `${currentUserTest.empPfNo}`,
      });

      const cloneReq = request.clone({ headers, withCredentials: false });
      // console.log("cloneReq: ", cloneReq);
      return next.handle(cloneReq);
    }
    // if (!currentUser) {
    //   // clone the request and add the Authorization header
    //   const cloneReq = request.clone({
    //     withCredentials: false,
    //   });
    //   // send the modified request
    //   return next.handle(cloneReq);
    // }
    return next.handle(request.clone());
  }
}
